// extracted by mini-css-extract-plugin
export default {"active":"__main_active__StY1Y"};